var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[(_vm.toolbar)?_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.title)?_c('v-spacer'):_vm._e(),_vm._t("actions")],2):_vm._e(),(_vm.scrollbar)?_c('perfect-scrollbar',[_vm._t("default")],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }